import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerMarketingInsightsMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('marketingInsights', locale)
}
